<template>
  <div class="gestionale">
    <NavBar />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'Gestionale',
  components: {
    NavBar
  }
}
</script>